/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistryImageSearch200ResponseCounts } from './RegistryImageSearch200ResponseCounts'
import {
  RegistryImageSearch200ResponseCountsFromJSON,
  RegistryImageSearch200ResponseCountsFromJSONTyped,
  RegistryImageSearch200ResponseCountsToJSON,
} from './RegistryImageSearch200ResponseCounts'
import type { RegistryImageSearch200ResponsePagination } from './RegistryImageSearch200ResponsePagination'
import {
  RegistryImageSearch200ResponsePaginationFromJSON,
  RegistryImageSearch200ResponsePaginationFromJSONTyped,
  RegistryImageSearch200ResponsePaginationToJSON,
} from './RegistryImageSearch200ResponsePagination'
import type { RegistrySearchItem } from './RegistrySearchItem'
import {
  RegistrySearchItemFromJSON,
  RegistrySearchItemFromJSONTyped,
  RegistrySearchItemToJSON,
} from './RegistrySearchItem'

/**
 *
 * @export
 * @interface SiteRegistrySearch200Response
 */
export interface SiteRegistrySearch200Response {
  /**
   *
   * @type {boolean}
   * @memberof SiteRegistrySearch200Response
   */
  status: boolean
  /**
   *
   * @type {Array<RegistrySearchItem>}
   * @memberof SiteRegistrySearch200Response
   */
  data: Array<RegistrySearchItem>
  /**
   *
   * @type {RegistryImageSearch200ResponseCounts}
   * @memberof SiteRegistrySearch200Response
   */
  counts?: RegistryImageSearch200ResponseCounts
  /**
   *
   * @type {RegistryImageSearch200ResponsePagination}
   * @memberof SiteRegistrySearch200Response
   */
  pagination?: RegistryImageSearch200ResponsePagination
}

/**
 * Check if a given object implements the SiteRegistrySearch200Response interface.
 */
export function instanceOfSiteRegistrySearch200Response(
  value: object
): value is SiteRegistrySearch200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function SiteRegistrySearch200ResponseFromJSON(
  json: any
): SiteRegistrySearch200Response {
  return SiteRegistrySearch200ResponseFromJSONTyped(json, false)
}

export function SiteRegistrySearch200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SiteRegistrySearch200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(RegistrySearchItemFromJSON),
    counts:
      json['counts'] == null
        ? undefined
        : RegistryImageSearch200ResponseCountsFromJSON(json['counts']),
    pagination:
      json['pagination'] == null
        ? undefined
        : RegistryImageSearch200ResponsePaginationFromJSON(json['pagination']),
  }
}

export function SiteRegistrySearch200ResponseToJSON(
  value?: SiteRegistrySearch200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(RegistrySearchItemToJSON),
    counts: RegistryImageSearch200ResponseCountsToJSON(value['counts']),
    pagination: RegistryImageSearch200ResponsePaginationToJSON(
      value['pagination']
    ),
  }
}
